import React, { useCallback, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'

import { PermissionGuard } from '../../../common/components/routes'
import { PERMISSIONS } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useLoggedInUser } from '../../../common/hooks'

import { useDeleteUserMutation } from '../../hooks'
import { userDetailsPropType } from '../../prop-types'

const UsersTableActionColumn = ({ user }) => {
  const loggedInUser = useLoggedInUser(user)
  const isLoggedInUser = Number(user.id) === Number(loggedInUser.id)

  const [deleteUser, { error, idToDelete }] = useDeleteUserMutation()

  useEffect(() => {
    if (error && Number(user.id) === Number(idToDelete.id)) {
      showErrorNotification({
        title: 'User deletion failed',
        description: error,
      })
    }
  }, [error, idToDelete, user.id])

  const handleDeleteUser = useCallback(
    () => deleteUser(user.id),
    [deleteUser, user.id],
  )

  return (
    <>
      <PermissionGuard permissions={PERMISSIONS.USER.UPDATE}>
        <Button>
          <Link to={`/users/${user.id}`}>Edit</Link>
        </Button>
      </PermissionGuard>
      <PermissionGuard permissions={PERMISSIONS.USER.DELETE}>
        <Popconfirm
          title="Are you sure you want to delete this user?"
          disabled={isLoggedInUser}
          onConfirm={handleDeleteUser}
          placement="left"
          okText="Yes"
          cancelText="No"
        >
          <Button disabled={isLoggedInUser}>
            <DeleteOutlined />
          </Button>
        </Popconfirm>
      </PermissionGuard>
    </>
  )
}

UsersTableActionColumn.propTypes = {
  user: userDetailsPropType.isRequired,
}

export default UsersTableActionColumn
